import styled, { createGlobalStyle } from 'styled-components';
import React from 'react';

const UiMask = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${(props) => props.theme.color.mask};
`;

const Input = styled.input.attrs((props) => {
  return {
    className: props.sm ? 'sm' : '',
  };
})`
  padding: 4px 6px;
  vertical-align: middle;
  box-sizing: border-box;
  font-size: var(--fs-md);
  line-height: 1.42857143;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  resize: none;
  height: 36px;

  &:hover {
    border-color: ${(props) => props.theme.color.info};
  }

  &.block {
    width: 100%;
    display: block;
  }

  &.sm {
    height: 30px;
  }

  &.error {
    border-color: ${(props) => props.theme.color.warn};
  }
`;

const Select = (props) => {
  return <Input as={'select'} {...props} />;
};

const CheckBox = styled.span`
  display: inline-block;
  border-radius: 2px;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border: solid 1px ${(props) => props.theme.color.primary};
  background-color: #fff;
  position: relative;

  &.on {
    background-color: ${(props) => props.theme.color.primary};

    &:after {
      position: absolute;
      left: 50%;
      top: 40%;
      z-index: 10;
      content: '';
      transform: translate(-50%, -50%) rotate(45deg);
      width: 4px;
      height: 8px;
      border: solid 2px transparent;
      border-right-color: #fff;
      border-bottom-color: #fff;
    }
  }
`;

const RoundCheckBox = styled(CheckBox)`
  border-radius: 50%;
`;

const RadioButton = styled.span`
  display: inline-block;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  border: solid 1px #a3a3a3;
  background-color: #fff;
  position: relative;
  vertical-align: middle;
  margin-right: 4px;

  &.on {
    border-color: ${(props) => props.theme.color.primary};

    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 10;
      content: '';
      transform: translate(-50%, -50%) rotate(45deg);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${(props) => props.theme.color.primary};
    }
  }
`;

const Avatar = styled.div`
  display: inline-block;
  width: ${(props) => props.size || 40}px;
  height: ${(props) => props.size || 40}px;

  img {
    vertical-align: top;
    width: ${(props) => props.size || 40}px;
    height: ${(props) => props.size || 40}px;
  }
`;

const RoundAvatar = styled(Avatar)`
  border-radius: 50%;

  img {
    border-radius: 50%;
  }
`;

export {
  UiMask,
  Input,
  Select,
  CheckBox,
  RoundCheckBox,
  Avatar,
  RoundAvatar,
  RadioButton,
};
